import React from 'react';
import PageHeader from '../components/PageHeader';
import AppHeader from '../components/AppHeader';
import NavBar from '../components/NavBar';

const handleExternalLink = (content) => {
	if(content) {
		content.addEventListener('click', (e) => {
			const target = e.target;

			if(target.tagName === 'A' && target.getAttribute('href').indexOf('http') >= 0) {
				e.preventDefault();
				e.stopPropagation();

				window.open(target.getAttribute('href'), '_blank');

				return false;
			}
		});
	}
};

export default ({ i18nPath, children, headerAlign }) => (
  <div>
    <AppHeader>
      <NavBar />
    </AppHeader>
    <PageHeader i18nPath={i18nPath} align={headerAlign} />
    <div ref={handleExternalLink} className="static-page">
    	{children}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/StaticPage.js